// src/pages/Customer/RestaurantMenu.jsx
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

const CustomerMenu = () => {
  const { id } = useParams();
  const [cart, setCart] = useState([]);
  const [activeCategory, setActiveCategory] = useState('recommended');

  const restaurant = {
    id: 1,
    name: "Burger King",
    rating: 4.3,
    deliveryTime: "30 min",
    price: "₹200 for one",
    cuisines: ["Burgers", "American", "Fast Food"],
    address: "Connaught Place, New Delhi",
    offers: ["50% OFF up to ₹100", "Free delivery on orders above ₹299"]
  };

  const menuCategories = [
    { id: 'recommended', name: 'Recommended' },
    { id: 'burgers', name: 'Burgers' },
    { id: 'sides', name: 'Sides' },
    { id: 'beverages', name: 'Beverages' },
    { id: 'desserts', name: 'Desserts' }
  ];

  const menuItems = {
    recommended: [
      { id: 1, name: "Whopper", price: 199, description: "Our signature burger with flame-grilled beef", image: "/whopper.jpg", veg: false },
      { id: 2, name: "Veg Whopper", price: 179, description: "Vegetarian version of our signature burger", image: "/veg-whopper.jpg", veg: true }
    ],
    burgers: [
      // More burger items...
    ]
  };

  const addToCart = (item) => {
    setCart(prev => {
      const existing = prev.find(cartItem => cartItem.id === item.id);
      if (existing) {
        return prev.map(cartItem => 
          cartItem.id === item.id 
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      }
      return [...prev, { ...item, quantity: 1 }];
    });
  };

  const cartTotal = cart.reduce((total, item) => total + (item.price * item.quantity), 0);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Restaurant Header */}
      <div className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-6">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-2xl font-bold">{restaurant.name}</h1>
              <p className="text-gray-600">{restaurant.cuisines.join(', ')}</p>
              <p className="text-sm text-gray-500">{restaurant.address}</p>
              <div className="flex gap-4 mt-2 text-sm">
                <span>⭐ {restaurant.rating}</span>
                <span>🛵 {restaurant.deliveryTime}</span>
                <span>💲 {restaurant.price}</span>
              </div>
            </div>
            <div className="text-right">
              <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
                ✓ 5000+ ratings
              </div>
            </div>
          </div>

          {/* Offers */}
          <div className="mt-4 flex gap-2 overflow-x-auto">
            {restaurant.offers.map((offer, index) => (
              <div key={index} className="bg-red-50 text-red-600 px-3 py-1 rounded text-sm whitespace-nowrap">
                🎁 {offer}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Menu Categories */}
      <div className="sticky top-0 bg-white shadow-sm z-10">
        <div className="container mx-auto px-4">
          <div className="flex gap-6 overflow-x-auto">
            {menuCategories.map(category => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`py-4 whitespace-nowrap border-b-2 ${
                  activeCategory === category.id
                    ? 'border-red-600 text-red-600 font-semibold'
                    : 'border-transparent text-gray-600'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Menu Items */}
      <div className="container mx-auto px-4 py-6">
        <div className="space-y-4">
          {menuItems[activeCategory]?.map(item => (
            <div key={item.id} className="bg-white rounded-lg p-4 flex justify-between items-start">
              <div className="flex-1">
                {item.veg ? (
                  <span className="text-green-600 text-lg">🟢</span>
                ) : (
                  <span className="text-red-600 text-lg">🔴</span>
                )}
                <h3 className="font-semibold">{item.name}</h3>
                <p className="text-gray-600 text-sm mt-1">₹{item.price}</p>
                <p className="text-gray-500 text-sm mt-1">{item.description}</p>
              </div>
              
              <div className="flex flex-col items-end">
                <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded" />
                <button
                  onClick={() => addToCart(item)}
                  className="mt-2 bg-red-600 text-white px-4 py-1 rounded text-sm hover:bg-red-700"
                >
                  ADD +
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Cart Footer */}
      {cart.length > 0 && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg">
          <div className="container mx-auto px-4 py-3">
            <div className="flex justify-between items-center">
              <div>
                <span className="font-semibold">{cart.length} items</span>
                <span className="text-gray-600 ml-2">• ₹{cartTotal}</span>
              </div>
              <Link to="/customer/cart" className="bg-red-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-red-700">
                View Cart • ₹{cartTotal}
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerMenu;